import { Component, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { Observable, of } from 'rxjs';
import { CommonService } from 'src/app/core/common.service';
import * as currencyCodes from 'src/assets/currency-codes.json';

@Component({
  selector: 'eos-currency-field',
  templateUrl: './currency-field.component.html',
  styleUrls: ['./currency-field.component.css']
})
export class CurrencyFieldComponent extends FieldType implements OnInit {

  currencyCodes: Observable<any[]>;
  amountControl: AbstractControl;
  currencyCode: AbstractControl;
  
  amount: string = 'amount';
  currencyKey:string = 'currencyCode';
  
  constructor(private commonService: CommonService) { 
    super();
  }

  ngOnInit() {

    if(this.to.amountKey && this.to.amountKey.length >0){
        this.amount = this.to.amountKey;
    }

    if(this.to.currencyKey && this.to.currencyKey.length >0){
        this.currencyKey = this.to.currencyKey;
    }

    //console.log(this.currencyKey, this.amount)

     this.amountControl = this.formControl.get(this.amount);
     this.currencyCode = this.formControl.get(this.currencyKey);

     this.getCodes();
  }

  getCodes(){
    this.currencyCodes = this.commonService.getCurrencyCodes();
  }

}
